var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CustomVueEditor',{staticClass:"editor w-100",attrs:{"modelTypeId":_vm.LESSON_TEXT_MODEL_TYPE},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }